import React from 'react';
import { CoreContainer } from '@hub/core-container';
import { Box } from '@hub/box';
import { Grid } from '@hub/grid';
import { Text } from '@hub/text';
import { CloudinaryImage } from '../cloudinary-image';
import { TrackBox } from '../../analytics-observer/track-box';
import TileLink from '../tile-list/tile-link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function UtilityPanel(_ref) {
  let {
    items,
    as,
    clickEvent
  } = _ref;
  const iconHeight = 'size-icon-md';
  return /*#__PURE__*/_jsx(CoreContainer, {
    as: as,
    "data-id": "utility-panel_index_UtilityPanel_CoreContainer",
    children: /*#__PURE__*/_jsx(Box, {
      align: "center",
      "data-id": "utility-panel_index_UtilityPanel_CoreContainer_Box",
      children: /*#__PURE__*/_jsx(Grid, {
        templateColumns: ['repeat(auto-fit, calc(50% - var(--chakra-space-spacing-sm)))', 'repeat(auto-fit, calc(33.33% - var(--chakra-space-spacing-sm)))', 'repeat(auto-fit, calc(25% - var(--chakra-space-spacing-sm)))', 'repeat(auto-fit, calc(20% - var(--chakra-space-spacing-sm)))', 'repeat(auto-fit, calc(16.67% - var(--chakra-space-spacing-sm)))'],
        gap: ['spacing-sm'],
        sx: {
          justifyContent: 'center',
          alignItems: 'stretch',
          gridAutoRows: '1fr',
          justifyItems: 'stretch'
        },
        "data-id": "utility-panel_index_UtilityPanel_Box_Grid",
        children: items.map((entry, i) => /*#__PURE__*/_jsx(TrackBox, {
          onCreateImpressionWhenView: entry.viewItem,
          "data-id": "utility-panel_index_UtilityPanel_TrackBox",
          children: /*#__PURE__*/_jsxs(TileLink, {
            url: entry.callToAction.url,
            as: entry.as,
            onClick: () => {
              if (clickEvent) {
                clickEvent(i);
              }
            },
            "data-id": "utility-panel_index_UtilityPanel_TrackBox_TileLink",
            children: [/*#__PURE__*/_jsx(CloudinaryImage, {
              ratio: "1",
              imageSetOrImage: {
                type: 'SQUARE',
                url: entry.image.url,
                alt: entry.image.alt || entry.title
              },
              sx: {
                boxSize: iconHeight
              },
              sizes: 24,
              "data-id": "utility-panel_index_UtilityPanel_TileLink_CloudinaryImage"
            }), /*#__PURE__*/_jsx(Text, {
              isBodyText: true,
              align: "center",
              tone: "strong",
              sx: {
                marginTop: 'spacing-sm'
              },
              "data-id": "utility-panel_index_UtilityPanel_TileLink_Text",
              children: entry.title
            })]
          })
        }, i))
      })
    })
  });
}

export default UtilityPanel;